module.exports = __webpack_public_path__ + "static/stevenSpielbergGif-4be7020468e73d591f390c5887686e7e.gif";